module.exports = __webpack_public_path__ + "static/Vector Smart Object-01b91a8043df2aef0d5dca0c00b2d640.png";